// RGB color type

import type { ColorComponent } from "../Units"

export type RGBColor = {
  alpha: ColorComponent
  blue: ColorComponent
  green: ColorComponent
  red: ColorComponent
}
